import React, { useEffect, useState } from "react";
import api from "../api/api";
import { IMAGE_URL } from "../path";
import Header from "./Components/Header";
import '../styles/Home.css';
import FooterWithSignup from "./Components/FooterWithSignup";
import TestimonialsSection from "./Components/TestimonialsSection";
import HomeRecipeSection from "./Components/HomeRecipeSection";
import HomeProductsSection from "./Components/HomeProductsSection";
import {Link, useNavigate} from "react-router-dom";
import SEO from "./Components/SEO";

type HomePageData = {
    cuisine_image: string;
    product_image: string;
    recipes: string;
    ranges: string;
    gallery: {
        id: number;
        image: string;
        link: string;
    }[];
    featured_products: {
        product_image: string;
        slug: string;
    }[];
    featured_recipes: {
        name: string;
        slug: string;
        featured_image: string;
        preparation_time: string;
        cooking_time: string;
        servings: string;
        product_slug: string;
        occasion: string;

    }[];
    testimonials: {
        rating: number;
        comment: string;
        name: string;
        place: string;
    }[];
};

function HomePage() {
    const navigate = useNavigate();
    const [homePage, setHomePage] = useState<HomePageData | null>(null);
    const [loading, setLoading] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);
    const previousSlide = () => {
        setCurrentSlide((current) => Math.max(current - 1, 0));
    };
    const nextSlide = () => {
        setCurrentSlide((current) =>
            Math.min(current + 1, (homePage?.gallery.length ?? 1) - 1)
        );
    };

    // useEffect(() => {
    //     alert(
    //         Array.from(document.querySelectorAll('meta[name="viewport"]'))
    //             .map(m => m.outerHTML)
    //             .join("\n\n")
    //     );
    // }, []);


    async function loadHomePage() {
        try {
            const response = await api.get<HomePageData>("/fetch-home-page");

            setHomePage(response.data);
        } catch (error) {
            console.error("Failed to load home page", error);
        } finally {
            setLoading(false);

        }
    }

    useEffect(() => {
        loadHomePage();
    }, []);

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () =>
            window.removeEventListener(
                "resize",
                handleResize
            );
    }, []);


    if (loading) {
        return (
            <div className="page">
                <div className="page-content">
                    <div className="carton-background">
                        <Header />

                        <div className="heading-section">
                            <div className="anyone-can-cook">
                                <div className="skeleton title"></div>
                                <div className="skeleton text"></div>
                                <div className="skeleton text short"></div>

                                <div className="heading-buttons">
                                    <div className="skeleton button"></div>
                                    <div className="skeleton button"></div>
                                </div>
                            </div>

                            <div className="heading-right">
                                <div className="skeleton hero-image"></div>
                            </div>
                        </div>
                    </div>

                    <div className="home-section">
                        <div className="skeleton section-title"></div>
                        <div className="skeleton section-text"></div>
                        <div className="cards">
                            <div className="skeleton card"></div>
                            <div className="skeleton card"></div>
                            <div className="skeleton card"></div>
                        </div>
                    </div>

                    <div className="home-section">
                        <div className="skeleton section-title"></div>
                        <div className="cards">
                            <div className="skeleton product-card"></div>
                            <div className="skeleton product-card"></div>
                            <div className="skeleton product-card"></div>
                            <div className="skeleton product-card"></div>
                        </div>
                    </div>

                    <FooterWithSignup />
                </div>
            </div>
        );
    }

    if (!homePage) {
        return <div>Unable to load home page.</div>;
    }




    return (
        <div className="page">
            <SEO
                title="DENNY | Savour the Flavour"
                description="Discover premium DENNY products, delicious recipes and cooking inspiration. From everyday meals to special occasions, savour the flavour with DENNY."
                keywords="DENNY, recipes, cooking inspiration, meal ideas, sauces, stocks, mushrooms, easy recipes, home cooking, savour the flavour"
            />
            <div className="page-content">
                <div className="carton-background">
                    <Header />

                    {/*Main Heading Section*/}
                    <div className="heading-section">
                        <div className="anyone-can-cook">
                            <h1>Now, anyone can cook</h1>
                            <p>With premium ingredients, simple recipes, and the unmistakable Denny flavour.</p>
                            <div className="heading-buttons">
                                <Link to="/lets-cook" className="home-start-cooking-button">Start Cooking</Link>
                                <Link to="/products" className="home-start-cooking-button">Shop the Range</Link>
                            </div>
                        </div>
                        <div className="heading-right">
                            <div className="heading-gallery-wrapper">
                                <div
                                    className="heading-gallery"
                                    style={{
                                        transform: isMobile
                                            ? `translateX(-${currentSlide * 100}%)`
                                            : `translateX(-${currentSlide * (550 + 20)}px)`
                                    }}
                                >
                                    {homePage.gallery.map((image) => (
                                        <div className="gallery-item-wrapper" key={image.id}>
                                            <div className="gallery-item" >
                                                <img
                                                    onClick={() => navigate(image.link)}
                                                    src={`${IMAGE_URL}${image.image}`}
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="gallery-navigation">
                                <div onClick={previousSlide} className="arrow-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                        <g id="Group_918" data-name="Group 918" transform="translate(-792 -942)">
                                            <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" transform="translate(792 942)" fill="#436ab3"/>
                                            <path id="Path_14050" data-name="Path 14050" d="M13.25,4.5l-5,5,5,5" transform="translate(792.75 945)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                        </g>
                                    </svg>
                                </div>
                                {homePage.gallery.map((_, index) => (
                                    <div
                                        key={index}
                                        className={`navigation-dot ${currentSlide === index ? "active" : ""}`}
                                    />
                                ))}
                                <div onClick={nextSlide} className="arrow-icon">
                                    <svg id="Group_917" data-name="Group 917" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                        <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" fill="#436ab3"/>
                                        <path id="Path_14050" data-name="Path 14050" d="M8.25,4.5l5,5-5,5" transform="translate(2.75 3)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <HomeRecipeSection recipes_blurb={homePage.recipes} featured_recipes={homePage.featured_recipes} cuisine_image={homePage.cuisine_image} product_image={homePage.product_image} />
                <HomeProductsSection ranges={homePage.ranges} featured_products={homePage.featured_products} />
                <TestimonialsSection testimonials={homePage.testimonials} />
                <FooterWithSignup />
            </div>
        </div>
    );
}

export default HomePage;
